import VerifiedIcon from "@mui/icons-material/Verified";
import CloseIcon from "@mui/icons-material/Close";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { BadgeContainer } from "../../organisms/federationVerification/styles";

interface FederationBadgeProps {
  verified: boolean;
  federationSlug?: string | null;
  expiresAt?: string | null;
  compact?: boolean;
}

const FederationBadge = ({
  verified,
  federationSlug,
  expiresAt,
  compact = false,
}: FederationBadgeProps) => {
  if (!federationSlug) return null;

  const isExpired = expiresAt ? new Date(expiresAt) < new Date() : false;
  const slug = federationSlug.toUpperCase();

  if (verified && !isExpired) {
    return (
      <BadgeContainer $variant="success">
        <VerifiedIcon sx={{ fontSize: 14 }} />
        {compact ? slug : `Filiado ${slug}`}
      </BadgeContainer>
    );
  }

  if (isExpired) {
    return (
      <BadgeContainer $variant="warning">
        <HourglassEmptyIcon sx={{ fontSize: 14 }} />
        {compact ? slug : `Expirado ${slug}`}
      </BadgeContainer>
    );
  }

  return (
    <BadgeContainer $variant="error">
      <CloseIcon sx={{ fontSize: 14 }} />
      {compact ? slug : `Não filiado ${slug}`}
    </BadgeContainer>
  );
};

export default FederationBadge;
